import React, { Fragment } from "react";
import { PagedResponse } from "@ofqual/portal-core/core/types";
import { IconButton } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";

type SearchDialogPagerProps = {
  isLoading: boolean;
  apiResponse: PagedResponse<any>;
  setRequestedPage: (pageIndex: number) => void;
};

export const SearchDialogPager: React.FC<SearchDialogPagerProps> = ({
  isLoading,
  apiResponse,
  setRequestedPage,
}) => {
  const totalPages = Math.ceil(apiResponse.count / apiResponse.pageSize);
  return (
    <Fragment>
      {isLoading && (
        <span style={{ color: "#aaaaaa" }}>
          {/* todo: better isLoading feedback, shouldn't hardcode color */}
          Loading, please wait...
        </span>
      )}
      {!isLoading && (
        <Fragment>
          {apiResponse.count} records
          {apiResponse.page !== undefined && apiResponse.count !== 0 && (
            <Fragment>
              {" "}
              - page {apiResponse.page + 1} of {totalPages}
            </Fragment>
          )}
        </Fragment>
      )}
      <IconButton
        data-test="pager-previous"
        onClick={() => setRequestedPage(apiResponse.page! - 1)}
        disabled={isLoading || apiResponse.page === 0}
      >
        <ChevronLeft />
      </IconButton>
      <IconButton
        data-test="pager-next"
        onClick={() => setRequestedPage(apiResponse.page! + 1)}
        disabled={
          isLoading ||
          apiResponse.count === 0 ||
          apiResponse.page === totalPages! - 1
        }
      >
        <ChevronRight />
      </IconButton>
    </Fragment>
  );
};
